import React from 'react';
import { Phone, ExternalLink, Heart, ShieldAlert, AlertCircle, HelpCircle, Info } from 'lucide-react';

const AkutHjaelp = () => {
  const cards = [
    {
      title: "Ring 112",
      desc: "Ved akut fare for dig selv eller andre.",
      btnText: "Ring 112",
      link: "tel:112",
      isPhone: true,
      icon: Phone
    },
    {
      title: "Psykiatrisk akutmodtagelse",
      desc: "Kontakt din nærmeste psykiatriske akutmodtagelse ved akut behov.",
      btnText: "Find akutmodtagelse",
      link: "https://www.psykiatri-regionh.dk/",
      isPhone: false,
      icon: AlertCircle
    },
    {
      title: "Akuttelefonen 1813",
      desc: "Ring 1813 ved akut behov for hjælp uden for egen læges åbningstid.",
      btnText: "Læs mere om 1813",
      link: "https://www.regionh.dk/sundhed/akut/praktisk_information/sider/1813.aspx",
      isPhone: false,
      icon: Phone
    },
    {
      title: "Psykiatrisk akut hjælp i Region Hovedstaden",
      desc: "Se muligheder for akut psykiatrisk hjælp og akutmodtagelser.",
      btnText: "Se akut hjælp",
      link: "https://www.regionh.dk/sundhed/akut/sider/psykiatri.aspx",
      isPhone: false,
      icon: ExternalLink
    },
    {
      title: "Livslinien – 70 201 201",
      desc: "Kontakt Livslinien, hvis du har selvmordstanker og har brug for at tale med nogen.",
      btnText: "Besøg Livslinien",
      link: "https://www.livslinien.dk/raadgivning/telefonraadgivning",
      isPhone: false,
      icon: HelpCircle
    }
  ];

  return (
    <div className="mt-16 bg-[#FAF7F2] rounded-3xl border border-[#E8DDCE] p-6 md:p-10 shadow-sm max-w-7xl mx-auto">
      {/* Header */}
      <div className="text-center max-w-2xl mx-auto mb-10 flex flex-col items-center">
        <div className="inline-flex items-center gap-2.5 text-[#123F13] mb-4">
          <h3 className="text-xl md:text-2xl font-serif font-semibold text-[#123F13]">
            Akut hjælp ved psykisk krise
          </h3>
        </div>
        
        <p className="text-sm md:text-base text-[#3B352F]/85 leading-relaxed max-w-xl">
          Hvis du oplever en akut psykisk krise, har selvmordstanker eller føler dig i fare, er det vigtigt, at du rækker ud og søger professionel hjælp med det samme.
        </p>

        <div className="mt-5 flex items-center gap-2 text-[#123F13] bg-[#123F13]/5 px-5 py-2 rounded-full border border-[#123F13]/10 shadow-xs">
          <Heart size={14} className="fill-[#123F13] animate-pulse" />
          <span className="text-xs md:text-sm font-medium tracking-wide">
            Du er vigtig. Der er altid hjælp at få.
          </span>
        </div>
      </div>

      {/* 5 Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
        {cards.map((card, index) => {
          const IconComponent = card.icon;
          return (
            <div 
              key={index} 
              className="bg-white border border-[#E8DDCE]/60 rounded-2xl p-5 flex flex-col justify-between shadow-xs hover:shadow-sm transition-all duration-200"
            >
              <div>
                <div className="w-10 h-10 rounded-full bg-[#FAF7F2] flex items-center justify-center text-[#123F13] mb-3.5">
                  <IconComponent size={18} />
                </div>
                <h4 className="font-serif font-bold text-[#123F13] text-sm mb-2 leading-snug">
                  {card.title}
                </h4>
                <p className="text-xs text-[#3B352F]/70 leading-relaxed mb-4">
                  {card.desc}
                </p>
              </div>
              <a
                href={card.link}
                target={card.isPhone ? undefined : "_blank"}
                rel={card.isPhone ? undefined : "noopener noreferrer"}
                className="inline-flex items-center justify-center gap-1.5 w-full bg-[#123F13] hover:bg-[#1f5220] text-white text-xs font-semibold py-2 px-3 rounded-lg transition-colors duration-200 text-center"
              >
                {card.btnText}
                {!card.isPhone && <ExternalLink size={12} />}
              </a>
            </div>
          );
        })}
      </div>

      {/* Footer Note */}
      <div className="border-t border-[#E8DDCE]/60 pt-6 flex flex-col sm:flex-row items-center justify-center gap-2 text-xs text-[#3B352F]/60 text-center sm:text-left">
        <Heart size={14} className="text-[#123F13]/80 flex-shrink-0" />
        <span>
          Lars tilbyder ikke akut krisehjælp. Denne information er med for at hjælpe dig sikkert videre, hvis du har brug for hjælp her og nu.
        </span>
      </div>
    </div>
  );
};

export default AkutHjaelp;
